import React from 'react';
import variables from '../../styles/variables.module.scss';
import Highlight from '../../components/Highlight';

import caseImg from '../../assets/frames/drumster-caseimg-min.webp';
import caseImgAlt from '../../assets/frames/drumster-caseimg-min.png';

import anim1Start from '../../assets/animations/drumster1-start.json';
import anim1Loop from '../../assets/animations/drumster1-loop.json';
import anim2Start from '../../assets/animations/drumster2-start.json';
import anim2Loop from '../../assets/animations/drumster2-loop.json';
import anim3Start from '../../assets/animations/drumster3-start.json';
import anim3Loop from '../../assets/animations/drumster3-loop.json';

import web from '../../assets/frames/drumster-web-min.jpg';
import extraimg1 from '../../assets/frames/drumster-extraimg1@2x-min.png';
import extraimg2 from '../../assets/frames/drumster-extraimg2@2x-min.png';
import extraimg3 from '../../assets/frames/drumster-extraimg3@2x-min.png';
import footerBanner from '../../assets/envImages/drumster-footerBanner@2x-min.png';
import hero from '../../assets/hero/drumster-hero@2x-min.png';

export default {
  key: 'drumster',
  path: '/cases/drumster',
  color: variables.drumster,
  title: 'Drumster',
  hero: { fall: hero },
  case: { main: caseImg, fall: caseImgAlt },
  environmentSecond: { fall: web },
  footerBanner: { fall: footerBanner },
  xtra: [
    { fall: extraimg1 },
    { fall: extraimg2 },
    { fall: extraimg3 },
  ],
  animations: [
    { start: anim1Start, loop: anim1Loop },
    { start: anim2Start, loop: anim2Loop },
    { start: anim3Start, loop: anim3Loop },
  ],
  titleBodyData: {
    0: {
      title: 'Smart cable drum recycling',
      body:
  <span>
    What if you could get paid while performing an environmental contribution? Drumster is a company specializing in the recycling of drums holding electric cables. To automate the process of ordering drum pick-up, identifying exact position, and paying out the reward, Drumster wanted to create a modern, and easy to use app for the full process.
    <br />
    <br />
    <span>Intended for both businesses, as well as everyday users (who can make money when finding drums that’s been left or dumped in unfortunate places), Drumster aims to make recycling rewarding and easy.</span>
  </span>,
    },
  },
  // quoteData: {
  //   quote: '.',
  //   name: 'Roy Nard',
  //   profession: 'CTO, Drumster Sverige AB',
  // },
  sideHeadingFirst: 'iOS & Android application',
  sideHeadingSecond: 'Developed in React Native',
  infoTitle: 'What we built',
  infoBody:
  <span>
    We App therefore sought to create a service that could be used both as a B2B system, as well as a high-quality smartphone app. The app features a sleek design, with connection to Geo-positioning. So that users can easily place out the drums they’ve found on a map, for Drumster to pick up.
    <br />
    <br />
    The app also contains a reward system, where users can calculate the amount they’ll receive. And subsequently have it paid out, either to their bank account, or a charity of their choice. Lastly the app contains features for inviting friends, co-workers or business partners, to simplify the growth of the app. The solution was built in
    {' '}
    <Highlight>React Native</Highlight>
    .
    <br />
    <br />
  </span>,
  infoData: {
    Scope: ['Scope', 'Project management', 'User experience', 'UI & UX design'],
    Deliverables: ['Deliverables', 'iOS development', 'Android development', 'Cross-platform', 'Software development'],
    Goal: ['Goal', 'Project management', 'User experience', 'UI & UX design', 'Maintanance/support'],
  },
};
